import * as API from '@/services/api'

export async function fetchIATTask(taskName) {
    const response = await API.get(`/api/iat/task/${taskName}`)
    return response.data
}

export async function answerIATTask(interactionInstanceId, itemId, result) {
    const response = await API.post(`/api/iat/task/result/${interactionInstanceId}/${itemId}`, result)
    return response.data
}